import React from 'react';
// import welcomImg from '../../../assets/images/home/welcome_image.jpg'

function banner() {
    return <div className='d-flex align-items-center justify-content-center' id="topBanner">
        <div className='text-center bgcolor'>
            <h1 className='text-white text-center'>
                Cooking Appliances, Redefined

                From the house of VB, comes smart and durable kitchen appliances that deliver exquisite tastes, and cookware that sticks for generations.

            </h1>
            <a href='/category/allproducts'>
                <button type="button" className="btn btn-outline-light px-5 py-2">Shop Now</button>
            </a>
        </div>
    </div>
}

export const TopBanner = banner;